/**
 *  페이지 이름
 */
export const ACCOUNT_USER_PAGE_NAME = {
  USER_LIST: '유저 리스트',
  USER_RANK: '유저 랭킹 리스트',
  USER_DETAIL: '유저 상세',
};

/**
 *  유저 로그인 타입 텍스트
 */
export const ACCOUNT_USER_LOGIN_TYPE_TEXT = {
  email: '이메일',
  kakao: '카카오톡',
  naver: '네이버',
  facebook: '페이스북',
  apple: '애플',
};

export const ACCOUNT_USER_LIST_TYPE_TEXT = {
  0: '이메일',
  1: '카카오톡',
  2: '네이버',
  3: '페이스북',
  4: '애플',
};

/**
 *  유저 로그인 타입 리스트
 */
export const ACCOUNT_USER_LOGIN_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: 0,
    name: '이메일',
  },
  {
    id: 1,
    name: '카카오톡',
  },
  {
    id: 2,
    name: '네이버',
  },
  {
    id: 3,
    name: '페이스북',
  },
  {
    id: 4,
    name: '애플',
  },
];

/**
 *  유저 계정 상태
 */
export const ACCOUNT_USER_DETAIL_STATUS = {
  /**
   *  비활성
   */
  INACTIVE: 'inactive',
  /**
   *  활성
   */
  ACTIVATE: 'active',
  /**
   *  구매자 자진 탈퇴
   */
  DELETE_FROM_USER: 'deleteFromUser',
};

export const ACCOUNT_USER_LIST_STATUS = {
  /**
   *  비활성
   */
  INACTIVE: 0,
  /**
   *  활성
   */
  ACTIVATE: 1,
  /**
   *  구매자 자진 탈퇴
   */
  WITHDRAWAL: 2,
};

/**
 *  유저 리스트 계정 상태 텍스트
 */
export const ACCOUNT_USER_STATUS_TEXT = {
  [ACCOUNT_USER_LIST_STATUS.INACTIVE]: '비활성',
  [ACCOUNT_USER_LIST_STATUS.ACTIVATE]: '활성',
  [ACCOUNT_USER_LIST_STATUS.WITHDRAWAL]: '구매자 자진 탈퇴',
};

/**
 *  유저 상세 계정 상태 텍스트
 */
export const ACCOUNT_USER_DETAIL_STATUS_TEXT = {
  [ACCOUNT_USER_DETAIL_STATUS.INACTIVE]: '비활성',
  [ACCOUNT_USER_DETAIL_STATUS.ACTIVATE]: '활성',
  [ACCOUNT_USER_DETAIL_STATUS.DELETE_FROM_USER]: '구매자 자진 탈퇴',
};

/**
 *  유저 계정 상태 SELECT 리스트
 */
export const ACCOUNT_USER_STATUS_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: ACCOUNT_USER_DETAIL_STATUS.INACTIVE,
    name: ACCOUNT_USER_DETAIL_STATUS_TEXT[ACCOUNT_USER_DETAIL_STATUS.INACTIVE],
  },
  {
    id: ACCOUNT_USER_DETAIL_STATUS.ACTIVATE,
    name: ACCOUNT_USER_DETAIL_STATUS_TEXT[ACCOUNT_USER_DETAIL_STATUS.ACTIVATE],
  },
  {
    id: ACCOUNT_USER_DETAIL_STATUS.DELETE_FROM_USER,
    name: ACCOUNT_USER_DETAIL_STATUS_TEXT[ACCOUNT_USER_DETAIL_STATUS.DELETE_FROM_USER],
  },
];

export const ACCOUNT_USER_LIST_STATUS_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: ACCOUNT_USER_LIST_STATUS.INACTIVE,
    name: ACCOUNT_USER_STATUS_TEXT[ACCOUNT_USER_LIST_STATUS.INACTIVE],
  },
  {
    id: ACCOUNT_USER_LIST_STATUS.ACTIVATE,
    name: ACCOUNT_USER_STATUS_TEXT[ACCOUNT_USER_LIST_STATUS.ACTIVATE],
  },
  {
    id: ACCOUNT_USER_LIST_STATUS.WITHDRAWAL,
    name: ACCOUNT_USER_STATUS_TEXT[ACCOUNT_USER_LIST_STATUS.WITHDRAWAL],
  },
];

/**
 *  기기 푸시 수신 상태
 */
export const ACCOUNT_USER_DEVICE_PUSH_STATUS_TEXT = {
  0: '비활성',
  1: '활성',
};

/**
 *  기기 푸시 알림 SELECT 리스트
 */
export const ACCOUNT_USER_DEVICE_PUSH_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: 0,
    name: '비활성',
  },
  {
    id: 1,
    name: '활성',
  },
];

/**
 *  성별 타입
 */
export const ACCOUNT_USER_GENDER_TYPE = {
  // 없음
  NOT_EXISTED: '',
  // 여성
  FEMALE: 'female',
  // 남성
  MALE: 'male',
};

/**
 *  성별 타입 텍스트
 */
export const ACCOUNT_USER_GENDER_TYPE_TEXT = {
  [ACCOUNT_USER_GENDER_TYPE['FEMALE']]: '여성',
  [ACCOUNT_USER_GENDER_TYPE['MALE']]: '남성',
  [ACCOUNT_USER_GENDER_TYPE['NOT_EXISTED']]: '없음',
};

/**
 *  기종 타입
 */
export const ACCOUNT_USER_VISITOR_DEVICE_TYPE_TEXT = {
  0: 'AOS',
  1: 'IOS',
};

/**
 *  이메일 및 sms  수신 타입
 */
export const ACCOUNT_USER_RECEIVE_TYPE = {
  // 미동의
  REJECT: false,
  // 동의
  RECEIVE: true,
};

/**
 *  이메일 및 sms 수신 타입 텍스트
 */
export const ACCOUNT_USER_RECEIVE_TYPE_TEXT = {
  [ACCOUNT_USER_RECEIVE_TYPE.REJECT]: '미동의',
  [ACCOUNT_USER_RECEIVE_TYPE.RECEIVE]: '동의',
};

/**
 *  유저 액션 이름
 */
export const USER_ACTIONS_NAME = 'accountUserActions';

/**
 *  유저 리스트가 없을 때 보여주는 텍스트
 */
export const ACCOUNT_USER_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 유저 리스트가 없습니다.';

/**
 *  유저 포인트 리스트가 없을 때 보여주는 텍스트
 */
export const ACCOUNT_USER_POINT_LIST_TABLE_EMPTY_TEXT = '포인트 내역이 없습니다.';

/**
 *  유저 디바이스 리스트가 없을 때 보여주는 텍스트
 */
export const ACCOUNT_USER_DEVICE_LIST_TABLE_EMPTY_TEXT = '디바이스 리스트가 없습니다.';

/**
 *  유저 디바이스 타임라인 리스트가 없을 때 보여주는 텍스트
 */
export const ACCOUNT_USER_DEVICE_TIMELINE_LIST_TABLE_EMPTY_TEXT = '디바이스 타임라인 리스트가 없습니다.';

/**
 *  유저 주문 리스트가 없을 때 보여주는 텍스트
 */
export const ACCOUNT_USER_ORDER_LIST_TABLE_EMPTY_TEXT = '주문 리스트가 없습니다.';

/**
 *  유저 쿠폰 리스트가 없을 때 보여주는 텍스트
 */
export const ACCOUNT_USER_COUPON_LIST_TABLE_EMPTY_TEXT = '쿠폰 리스트가 없습니다.';

/**
 *  유저 상세 페이지 텝 키
 */
export const ACCOUNT_USER_DETAIL_TAB_KEY = {
  /**
   *  유저 정보
   */
  USER_INFO: '0',
  /**
   *  주문 정보
   */
  ORDER_INFO: '1',
  /**
   *  쿠폰 정보
   */
  COUPON_INFO: '2',
  /**
   *  포인트 정보
   */
  POINT_INFO: '3',
  /**
   *  장바구니 정보
   */
  CART_INFO: '4',
  /**
   *  1:1 문의 내역 정보
   */
  CS_INQUIRY_INFO: '5',
  /**
   *  상품 문의 내역 정보
   */
  CS_QNA_INFO: '6',
  /**
   *  상품 후기 정보
   */
  CS_REVIEW_INFO: '7',
  /**
   *  팔로우한 태그 정보
   */
  TAG_INFO: '8',
  /**
   *  좋아요한 상품 정보
   */
  LIKE_PRODUCT_INFO: '9',
  /**
   *  좋아요한 브랜드 정보
   */
  LIKE_BRAND_INFO: '10',
  /**
   * 디바이스 리스트
   * */
  DEVICE_LIST: '11',
  /**
   *  등급 정보
   */
  GRADE_INFO: '12',
};

export const ACCOUNT_USER_BANK_ID = {
  NULL: 0,
  국민은행: 1,
  기업은행: 2,
  농협: 3,
  신한은행: 4,
  우리은행: 5,
  외환은행: 6,
  SC제일은행: 7,
  하나은행: 8,
  한국시티은행: 9,
  광주은행: 10,
  경남은행: 11,
  대구은행: 12,
  부산은행: 13,
  전북은행: 14,
  제주은행: 15,
  수협은행: 16,
  우체국: 17,
  산업은행: 18,
  새마을금고: 19,
  신협: 20,
  상호저축은행: 21,
  HSBC은행: 22,
  케이뱅크: 23,
  카카오뱅크: 24,
};

export const ACCOUNT_USER_BANK_NAME = {
  [ACCOUNT_USER_BANK_ID.NULL]: '없음',
  [ACCOUNT_USER_BANK_ID.국민은행]: '국민은행',
  [ACCOUNT_USER_BANK_ID.기업은행]: '기업은행',
  [ACCOUNT_USER_BANK_ID.농협]: '농협',
  [ACCOUNT_USER_BANK_ID.신한은행]: '신한은행',
  [ACCOUNT_USER_BANK_ID.우리은행]: '우리은행',
  [ACCOUNT_USER_BANK_ID.외환은행]: '외환은행',
  [ACCOUNT_USER_BANK_ID.SC제일은행]: 'SC제일은행',
  [ACCOUNT_USER_BANK_ID.하나은행]: '하나은행',
  [ACCOUNT_USER_BANK_ID.한국시티은행]: '한국시티은행',
  [ACCOUNT_USER_BANK_ID.광주은행]: '광주은행',
  [ACCOUNT_USER_BANK_ID.경남은행]: '경남은행',
  [ACCOUNT_USER_BANK_ID.대구은행]: '대구은행',
  [ACCOUNT_USER_BANK_ID.부산은행]: '부산은행',
  [ACCOUNT_USER_BANK_ID.전북은행]: '전북은행',
  [ACCOUNT_USER_BANK_ID.제주은행]: '제주은행',
  [ACCOUNT_USER_BANK_ID.수협은행]: '수협은행',
  [ACCOUNT_USER_BANK_ID.우체국]: '우체국',
  [ACCOUNT_USER_BANK_ID.산업은행]: '산업은행',
  [ACCOUNT_USER_BANK_ID.새마을금고]: '새마을금고',
  [ACCOUNT_USER_BANK_ID.신협]: '신협',
  [ACCOUNT_USER_BANK_ID.상호저축은행]: '상호저축은행',
  [ACCOUNT_USER_BANK_ID.HSBC은행]: 'HSBC은행',
  [ACCOUNT_USER_BANK_ID.케이뱅크]: '케이뱅크',
  [ACCOUNT_USER_BANK_ID.카카오뱅크]: '카카오뱅크',
};

/**
 *  계좌 은행 리스트
 */
export const ACCOUNT_USER_BANK_LIST = [
  { id: ACCOUNT_USER_BANK_ID.NULL, name: '없음' },
  { id: ACCOUNT_USER_BANK_ID.국민은행, name: '국민은행' },
  { id: ACCOUNT_USER_BANK_ID.기업은행, name: '기업은행' },
  { id: ACCOUNT_USER_BANK_ID.농협, name: '농협' },
  { id: ACCOUNT_USER_BANK_ID.신한은행, name: '신한은행' },
  { id: ACCOUNT_USER_BANK_ID.우리은행, name: '우리은행' },
  { id: ACCOUNT_USER_BANK_ID.외환은행, name: '외환은행' },
  {
    id: ACCOUNT_USER_BANK_ID.SC제일은행,
    name: 'SC제일은행',
  },
  { id: ACCOUNT_USER_BANK_ID.하나은행, name: '하나은행' },
  {
    id: ACCOUNT_USER_BANK_ID.한국시티은행,
    name: '한국시티은행',
  },
  { id: ACCOUNT_USER_BANK_ID.광주은행, name: '광주은행' },
  { id: ACCOUNT_USER_BANK_ID.경남은행, name: '경남은행' },
  { id: ACCOUNT_USER_BANK_ID.대구은행, name: '대구은행' },
  { id: ACCOUNT_USER_BANK_ID.부산은행, name: '부산은행' },
  { id: ACCOUNT_USER_BANK_ID.전북은행, name: '전북은행' },
  { id: ACCOUNT_USER_BANK_ID.제주은행, name: '제주은행' },
  { id: ACCOUNT_USER_BANK_ID.수협은행, name: '수협은행' },
  { id: ACCOUNT_USER_BANK_ID.우체국, name: '우체국' },
  { id: ACCOUNT_USER_BANK_ID.산업은행, name: '산업은행' },
  {
    id: ACCOUNT_USER_BANK_ID.새마을금고,
    name: '새마을금고',
  },
  { id: ACCOUNT_USER_BANK_ID.신협, name: '신협' },
  {
    id: ACCOUNT_USER_BANK_ID.상호저축은행,
    name: '상호저축은행',
  },
  { id: ACCOUNT_USER_BANK_ID.HSBC은행, name: 'HSBC은행' },
  { id: ACCOUNT_USER_BANK_ID.케이뱅크, name: '케이뱅크' },
  {
    id: ACCOUNT_USER_BANK_ID.카카오뱅크,
    name: '카카오뱅크',
  },
];

/**
 *  유저 상세 > 팔로우한 태그 정보 탭 > 팔로우 태그 리스트가 없을 때 보여주는 텍스트
 */
export const FOLLOW_TAG_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 팔로우 태그 리스트가 없습니다.';

/**
 *  유저 장바구니 타임라인 리스트 활동내역 타입
 */
export const ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE = {
  ADD: 6,
  REMOVE: 7,
};

/**
 *  유저 장바구니 타임라인 리스트 활동내역 타입 텍스트
 */
export const ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE_TEXT = {
  [ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE.ADD]: '추가',
  [ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE.REMOVE]: '삭제',
};

/**
 *  유저 장바구니 타임라인 리스트 활동내역 타입 SELECT LIST
 */
export const ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE_SELECT_LIST = [
  {
    id: ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE.ADD,
    name: ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE_TEXT[ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE.ADD],
  },
  {
    id: ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE.REMOVE,
    name: ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE_TEXT[
      ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE.REMOVE
    ],
  },
];

/**
 *  유저 좋아요한 상품 타임라인 리스트 활동내역 타입
 */
export const ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE = {
  LIKE: 8,
  UNLIKE: 9,
  CLICK: 5,
};

/**
 *  유저 좋아요한 상품 타임라인 리스트 활동내역 타입 텍스트
 */
export const ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE_TEXT = {
  [ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE.LIKE]: '좋아요 추가',
  [ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE.UNLIKE]: '좋아요 삭제',
  [ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE.CLICK]: '상품 클릭',
};

/**
 *  유저 좋아요한 상품 타임라인 리스트 활동내역 타입 SELECT LIST
 */
export const ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE_SELECT_LIST = [
  {
    id: ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE.LIKE,
    name: ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE_TEXT[
      ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE.LIKE
    ],
  },
  {
    id: ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE.UNLIKE,
    name: ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE_TEXT[
      ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE.UNLIKE
    ],
  },
  {
    id: ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE.CLICK,
    name: ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE_TEXT[
      ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_ACTION_LOG_TYPE.CLICK
    ],
  },
];

/**
 *  유저 상세 > 좋아요한 상품 정보 탭 > 좋아요한 상품 리스트가 없을 때 보여주는 텍스트
 */
export const LIKE_PRODUCT_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 좋아요한 상품 리스트가 없습니다.';

/**
 *  유저 상세 > 좋아요한 상품 정보 탭 > 좋아요한 브랜드 리스트가 없을 때 보여주는 텍스트
 */
export const LIKE_BRAND_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 좋아요한 브랜드 리스트가 없습니다.';

/**
 *  유저 좋아요한 브랜드 타임라인 리스트 활동내역 타입
 */
export const ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE = {
  LIKE: 11,
  UNLIKE: 12,
  CLICK: 10,
};

/**
 *  유저 좋아요한 브랜드 타임라인 리스트 활동내역 타입 텍스트
 */
export const ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE_TEXT = {
  [ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE.LIKE]: '좋아요 추가',
  [ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE.UNLIKE]: '좋아요 삭제',
  [ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE.CLICK]: '브랜드 클릭',
};

/**
 *  유저 좋아요한 브랜드 타임라인 리스트 활동내역 타입 SELECT LIST
 */
export const ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE_SELECT_LIST = [
  {
    id: ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE.LIKE,
    name: ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE_TEXT[
      ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE.LIKE
    ],
  },
  {
    id: ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE.UNLIKE,
    name: ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE_TEXT[
      ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE.UNLIKE
    ],
  },
  {
    id: ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE.CLICK,
    name: ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE_TEXT[
      ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE.CLICK
    ],
  },
];
